export function getEventLocation(
  pathname: string,
  options?: {
    isOfferDetails?: boolean;
    checkoutActiveScreen?: number;
  }
): string {
  const suffix = options?.isOfferDetails ? '_szczegóły_oferty' : '';
  const isCheckoutPaymentView =
    pathname.includes('/checkout/') && pathname.endsWith('/payment');

  if (pathname.includes('results')) {
    return `ranking${suffix}`;
  }

  if (pathname.includes('upsale')) {
    return `upsell${suffix}`;
  }

  if (isCheckoutPaymentView) {
    return `checkout_payment${suffix}`;
  }

  if (pathname.includes('checkout')) {
    if (options?.checkoutActiveScreen === 1) {
      return `checkout_dane_2${suffix}`;
    }
    return `checkout_dane_1${suffix}`;
  }

  return `ranking${suffix}`;
}
